import { FC } from 'react';

import { Alert, AlertProps } from '@mantine/core';
import { useLocalStorage } from '@mantine/hooks';

import { useIsIncognito } from 'hooks/use-is-incognito';

const DismissableNotice: FC<
    AlertProps & {
        identifier: string;
        refresh?: 'never' | 'daily' | 'monthly' | 'quarterly' | 'yearly';
    }
> = ({ identifier, refresh = 'never', children, ...props }) => {
    const rememberable = useIsIncognito() === false;

    const [dismissed, setLocalStorage] = useLocalStorage<boolean>({
        key: {
            'never': identifier,
            'daily': `${identifier}-${new Date().toDateString()}`,
            'monthly': `${identifier}-${new Date().getMonth()}`,
            'quarterly': `${identifier}-${Math.floor(new Date().getMonth() / 3)}`,
            'yearly': `${identifier}-${new Date().getFullYear()}`,
        }[refresh],
        getInitialValueInEffect: false,
    });

    const close = () => {
        setLocalStorage(true);
    };

    return dismissed || !rememberable ? null : (
        <Alert {...props} withCloseButton onClose={close}>
            {children}
        </Alert>
    );
};

export { DismissableNotice };
